module.exports = __webpack_public_path__ + "static/standalone/img/protect-umbrella.276709ce.svg";